import styled, { keyframes } from 'styled-components';
import { checkboxActive } from '../../assets/Images';

const FPTLogo = styled.img`
  display: block;
  max-height: 5vh;
  min-height: 25px;
  margin: 4vh auto 20px;
`;

const Spinner = styled.img`
    width: 50px;
    height: 50px;
    margin: 0 auto;
  `;

const ContentPanel = styled.div`
  flex: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap:  34px;
`;

const HeaderPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PollingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: white;
  font-family: Inter, sans-serif;
  font-weight: 500;
  border-radius: 15px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  margin-top: 0;
  width: 100%;
`;

const OptionsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const McOption = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  border: solid 2px #bbcad3;
  background-color: #fff;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000;
`;

const OptionLabel = styled.div`
  text-align: left;
`;

const McCheckbox = styled.div`
  width: 28px;
  height: 28px;
  flex-grow: 0;
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 8px;
  border: solid 2px #718490;
  background-color: #fff;

  &.active {
    width: 32px;
    height: 32px;
    border: none;
    background: no-repeat url(${checkboxActive});
  }
`;

const HeaderIcon = styled.img`
  width: 72px;
  margin: 0 auto;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-family: Inter, sans-serif;
  color: #1e4e5f;
`;

const Message = styled.div`
  opacity: 0.8;
  align-self: stretch;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #1e4e5f;
`;

const FooterWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export {
  ContentPanel,
  FooterWrapper,
  FPTLogo,
  HeaderIcon,
  HeaderPanel,
  McCheckbox,
  McOption,
  Message,
  OptionLabel,
  OptionsPanel,
  PollingCard,
  Spinner,
  Title,
};
